import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusCircle, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface LinkBrandRedirectionCardProps {
  className?: string;
  message?: string;
  isLoading?: boolean;
}

export const LinkBrandRedirectionCard: React.FC<LinkBrandRedirectionCardProps> = ({
  className = '',
  message,
  isLoading = false
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const handleConnectAccount = () => {
    navigate('/brand-strategy-lab?modal=analyze');
  };

  // Show skeleton loader during loading
  if (isLoading) {
    return (
      <div className={`relative rounded-xl border border-dashed border-gray-200 bg-gray-50 p-4 ${className}`}>
        <div className="flex flex-col items-center justify-center text-center p-4 animate-pulse">
          <div className="w-12 h-12 rounded-full bg-gray-200 mb-3"></div>
          <div className="h-5 bg-gray-200 rounded w-48 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-64 mb-4"></div>
          <div className="h-10 bg-gray-200 rounded w-40"></div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={`relative rounded-xl border border-dashed border-primary-300 bg-primary-50 hover:bg-primary-100 transition-colors p-4 cursor-pointer ${className}`}
      onClick={handleConnectAccount}
    >
      <div className="flex flex-col items-center justify-center text-center p-4">
        <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3">
          <PlusCircle className="w-6 h-6 text-primary-600" />
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {t('common.noBrandsAvailable')}
        </h3>

        <p className="text-sm text-gray-600 mb-4">
          {message || t('common.createBrandFirst')}
        </p>

        <button
          className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          onClick={handleConnectAccount}
        >
          {t('common.createBrand')}
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}; 